import React from "react";
import styled from "styled-components";

// Styled components
const LoadingPageWrap = styled.div`
  z-index: 101;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  // background: yellow;
  background: #fff;
  text-align: center;
  position: fixed;
  display: ${props => (props.hidden ? "hidden" : "flex")};
`;

const LoadingGIF = styled.div`
  margin: auto;
  /* For IE, a height is needed to push item down to center. Unlike Chrome, 'margin-top: auto' doesn't push it down in IE. */
  height: 50%;
`;

const LoadingPage = ({ isHidden, header }) => (
  <LoadingPageWrap hidden={isHidden}>
    <LoadingGIF>
      {header ? <h3> {header} </h3> : <h3> Getting flight info 😊</h3>}
      <img src="loading.gif" alt="loading" />
      <h3> Please wait... </h3>
    </LoadingGIF>
  </LoadingPageWrap>
);

export default LoadingPage;



// WEBPACK FOOTER //
// ./src/components/LoadingFlightsPage/index.js